import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from './_services/script-loader.service';
import { ThemeRoutingModule } from './theme/theme-routing.module';
import { AuthSharedModule } from './auth/auth.shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwnerUserService } from './services/owner-user.service';
import { PublisherService } from './services/publisher.service';
import { PublisherUserService } from './services/publisher-user.service';
import { RoleService } from './services/roles.service';
import { CustomerService } from './services/customer.service';
import { SiteService } from './services/site.service';
import { PageService } from './services/page.service';
import { SizeService } from './services/size.service';
import { AdUnitService } from './services/adunit.service';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RequestOptions, Http, XHRBackend } from '@angular/http';
import { ExtendedHttpService } from './_services/extended-http.service';
import { SweetAlertService } from './_services/sweetalert.service';
import { ValidationService } from './_services/validation.service';
import { GlobalErrorHandler } from './_services/error-handler.service';
import { SelectService } from './_services/select.service';
import { UserGroupService } from './services/user-group.service';
import { DataService } from './_services/data.service';
import { SettingService } from './services/setting.service';
import { MessageService } from './_services/message.service';
import { WebsocketService } from './_services/websocket.service';
import { AgencyService } from './services/agency.service';
import { DatatableService } from './_services/datatable.service';
import { ReservationService } from './services/reservation.service';
import { LoadingService } from './_services/loading.service';
import { DatepickerService } from './_services/datepicker.service';
import { ExcelService } from './_services/excel.sevice';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [ThemeComponent, AppComponent],
    imports: [
        FormsModule,
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthSharedModule,
        HttpClientModule,
        NgbModule.forRoot()
    ],
    providers: [
        ScriptLoaderService,
        OwnerUserService,
        UserGroupService,
        PublisherUserService,
        PublisherService,
        RoleService,
        ReservationService,
        SiteService,
        SettingService,
        PageService,
        SizeService,
        AdUnitService,
        CustomerService,
        AgencyService,
        SweetAlertService,
        ValidationService,
        SelectService,
        LoadingService,
        DataService,
        DatepickerService,
        DatatableService,
        WebsocketService,
        MessageService,
        ExcelService,
        {
            provide: Http,
            useFactory: (
                backend: XHRBackend,
                options: RequestOptions,
                router: Router,
                dataService: DataService
            ) => {
                return new ExtendedHttpService(backend, options, router, dataService);
            },
            deps: [XHRBackend, RequestOptions, Router]
        },
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/app.module.ts